<app-toolbar #toolbar></app-toolbar>
<mat-divider></mat-divider>
<div class="pix-card">
  <h2>Pagamento via PIX</h2>

  <div class="qrcode-wrapper">
    <qrcode
      [qrdata]="pixCopiaECola"
      [width]="220"
      [errorCorrectionLevel]="'M'">
    </qrcode>
  </div>

  <div class="pix-code">
    <label for="codigoPix">Código PIX (copia e cola)</label>
    <textarea id="codigoPix" readonly>{{ pixCopiaECola }}</textarea>
  </div>

  <button class="btn-copiar" (click)="copiarCodigo()">
    Copiar Código
  </button>
</div>
